import { cacheUtil } from '@beecode/msh-node-util/lib/cache-util';
import { authRepoFactory } from '@zeuslabsltd/common/lib/business/repo/auth-repo';
import { axiosAuthorisationInterceptor } from '@zeuslabsltd/react-common/lib/lib/axios/axios-authorisation-interceptor';

export const authRepo = cacheUtil.singleton(() =>
	authRepoFactory({ authorisedInterceptors: [axiosAuthorisationInterceptor] }),
);
